import React from 'react'
import ContentLoader from 'react-content-loader'

const DesktopLoader = () => (
    <div id="productTop" className="row">
        <div className="col-sm-12">
            <div className="rounded preload-widget">
                <ContentLoader
                    height={400}
                    width={1000}
                    speed={2}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="155.73" y="38.61" rx="0" ry="0" width="334.79" height="309.44" />
                    <rect x="38.63" y="44.61" rx="0" ry="0" width="59.78" height="61" />
                    <rect x="38.63" y="118.61" rx="0" ry="0" width="59" height="67" />
                    <rect x="38.63" y="195.61" rx="0" ry="0" width="58.8" height="64" />
                    <rect x="40.63" y="286.61" rx="0" ry="0" width="57" height="65.27" />
                    <rect x="550.63" y="64.61" rx="0" ry="0" width="174" height="30" />
                    <rect x="550.63" y="114.61" rx="0" ry="0" width="316" height="36" />
                    <rect x="552.63" y="171.61" rx="0" ry="0" width="177" height="38" />
                    <rect x="550.63" y="247.61" rx="0" ry="0" width="310" height="67" />
                </ContentLoader>
            </div>
        </div>
    </div>
)

export default DesktopLoader
